import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Leads } from '@/modules/leads/types';
import { CompaniesUsers } from './types';

const users_managers = CompaniesUsers.Pages.COMPANIES_USERS_MANAGERS;

const user_staff = CompaniesUsers.Pages.COMPANY_USER_STAFF;

const user_staff_details = CompaniesUsers.Pages.COMPANY_USER_STAFF_DETAILS;

const user_staff_edit = CompaniesUsers.Pages.COMPANY_USER_STAFF_EDIT;

const routes: RouteConfig[] = [
  {
    path: `/${users_managers}`,
    name: users_managers,
    component: () => import(/* webpackChunkName: "users" */ './views/CompaniesUsersManagers.vue'),
    meta: {
      access_roles: RouteRoles[users_managers],
    },
  },
  {
    path: `/:company_id/${user_staff}`,
    name: user_staff,
    component: () => import(/* webpackChunkName: "users" */ './views/CompanyUserStaff.vue'),
    meta: {
      access_roles: RouteRoles[user_staff],
    },
  },
  {
    path: `/:company_id/${user_staff}/:id`,
    name: user_staff_details,
    component: () => import(/* webpackChunkName: "users" */ './views/AdminStaffDetail.vue'),
    meta: {
      access_roles: RouteRoles[user_staff_details],
    },
  },
  {
    path: `/:company_id/${user_staff}/:id/edit`,
    name: user_staff_edit,
    component: () => import(/* webpackChunkName: "users" */ './views/AdminStaffEdit.vue'),
    meta: {
      access_roles: RouteRoles[user_staff_edit],
    },
  },
];

export default routes;
